<div class="flex items-center gap-x-sm mb-sm">
  <div class="flex items-center">
    @for (emoji of emojis(); track emoji) {
      <span class="font-medium text-neutral-500 text-xs tracking-[-0.25rem]">
        {{ emoji }}
      </span>
    }
  </div>

  <span class="font-medium text-xs2 text-neutral-700 relative">
    {{ commentReactions()[0].user.name }}
    @if (reactionCount() > 1) {
      {{ 'discussion_section_and_label' | transloco }}

      <button
        type="button"
        class="underline"
        (click)="toggleUserReactions.emit(!showAllReactions())">
        {{ reactionCount() - 1 }}
        {{ 'discussion_section_others_label' | transloco }}
      </button>

      @if (showAllReactions()) {
        <dialog
          open
          libClickOutSide
          (clickOutside)="toggleUserReactions.emit(false)"
          class="absolute bottom-full start-1/2 ltr:-translate-x-1/3 rtl:translate-x-1/3 z-10 min-w-[20.625rem] bg-white rounded-lg py-2xl px-lg shadow-md">
          <!-- reaction header -->
          <header
            class="flex items-center justify-between pb-md border-b border-neutral-200 mb-lg">
            <h6 class="text-base font-bold text-neutral-900">
              {{ 'discussion_section_reactions_label' | transloco }}
            </h6>

            <button type="button" (click)="toggleUserReactions.emit(false)">
              <lib-close-icon
                iconClass="size-5"
                stroke="var(--color-neutral-500)" />
            </button>
          </header>

          <!-- reaction views -->
          <div
            class="flex items-center justify-start gap-sm border-b border-neutral-200 mb-sm">
            <button
              type="button"
              class="text-base p-md flex items-center gap-sm"
              [class.text-neutral-500]="emojiActiveTab()"
              [class.border-b]="!emojiActiveTab()"
              [class.text-primary-500]="!emojiActiveTab()"
              [class.border-primary-500]="!emojiActiveTab()"
              (click)="toggleEmojiTab.emit(''); emojiActiveTab.set('')">
              {{ 'requests_screen_first_tab_label' | transloco }}

              @if (emojiActiveTab() === '' && !isReactionsLoading()) {
                <lib-badge
                  [label]="meta().total.toString()"
                  [badgeClass]="
                    'px-sm border-none text-xs font-medium bg-primary-50 text-primary-700'
                  " />
              }
            </button>

            @for (emoji of emojisLookup(); track emoji.id) {
              <button
                type="button"
                class="text-base p-md flex items-center gap-sm"
                [class.text-neutral-500]="emojiActiveTab() !== emoji.value"
                [class.border-b]="emojiActiveTab() === emoji.value"
                [class.text-primary-500]="emojiActiveTab() === emoji.value"
                [class.border-primary-500]="emojiActiveTab() === emoji.value"
                (click)="
                  toggleEmojiTab.emit(emoji.value);
                  emojiActiveTab.set(emoji.value)
                ">
                {{ emoji.emoji }}

                @if (
                  emojiActiveTab() === emoji.value && !isReactionsLoading()
                ) {
                  <lib-badge
                    [label]="meta().total.toString()"
                    [badgeClass]="
                      'px-sm border-none text-xs font-medium bg-primary-50 text-primary-700'
                    " />
                }
              </button>
            }
          </div>

          <!-- reaction users list  -->
          @if (isReactionsLoading()) {
            <div class="flex justify-center items-center py-lg">
              <lib-loader [size]="'sm'" />
            </div>
          } @else {
            <div
              class="max-h-[16.5rem] overflow-y-auto"
              [class.pe-sm]="allCommentReactions().length > 6">
              @for (
                reaction of allCommentReactions();
                track reaction.id;
                let last = $last
              ) {
                <div
                  class="flex items-center justify-between gap-md h-11 border-neutral-200"
                  [class.border-b]="!last">
                  <div class="flex items-center gap-md">
                    <lib-avatar
                      [fullName]="reaction.user.name"
                      [img]="reaction.user.image?.url ?? ''"
                      size="list"
                      borderRadius="rounded-full" />

                    <div class="text-xs text-neutral-900 font-medium">
                      {{ reaction.user.name }}
                    </div>
                  </div>

                  <span class="text-sm">
                    {{ reaction.emoji.emoji }}
                  </span>
                </div>
              }
            </div>
          }
        </dialog>
      }
    }
  </span>
</div>
